<template>
  <z-dialog
    v-model="store.visible"
    :title="store.isPrint ? t('z.export.printTitle') : t('z.export.expTitle')"
    width="560px"
    destroy-on-close
  >
    <div class="z-grid-export-form">
      <div v-if="!store.isPrint" class="z-grid-export-form__row">
        <label>{{ t('z.export.expName') }}</label>
        <z-input v-model="params.filename" />
      </div>
      <div v-if="!store.isPrint" class="z-grid-export-form__row">
        <label>{{ t('z.export.expType') }}</label>
        <z-select v-model="params.type" style="width: 100%">
          <z-option
            v-for="item in store.typeList"
            :key="item.value"
            :value="item.value"
            :label="t(item.label)"
          />
        </z-select>
      </div>
      <div class="z-grid-export-form__row">
        <label>{{ t('z.export.expMode') }}</label>
        <z-select v-model="params.mode" style="width: 100%">
          <z-option
            v-for="item in store.modeList"
            :key="item.value"
            :value="item.value"
            :label="t(item.label)"
          />
        </z-select>
      </div>
      <div class="z-grid-export-form__row">
        <label>{{ t('z.export.expColumn') }}</label>
        <div class="z-grid-export-columns">
          <z-checkbox
            v-for="col in store.columns"
            :key="col.id"
            v-model="col.checked"
            :disabled="col.disabled"
          >
            {{ col.title || col.field }}
          </z-checkbox>
        </div>
      </div>
    </div>
    <template #footer>
      <z-button @click="store.visible = false">{{ t('z.export.expCancel') }}</z-button>
      <z-button type="primary" :loading="loading" @click="confirm">
        {{ store.isPrint ? t('z.export.expPrint') : t('z.export.expConfirm') }}
      </z-button>
    </template>
  </z-dialog>
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue'
import ZButton from '@zoryn/components/button'
import ZCheckbox from '@zoryn/components/checkbox'
import ZDialog from '@zoryn/components/dialog'
import ZInput from '@zoryn/components/input'
import ZSelect, { ZOption } from '@zoryn/components/select'
import { useLocale } from '@zoryn/hooks'
import type { DataGrid } from '../types'

const { t } = useLocale()
const $grid = inject('$grid') as DataGrid
const loading = ref(false)

const store = computed(() => $grid.reactData.exportStore)
const params = computed(() => $grid.reactData.exportParams)

const confirm = () => {
  const expColumns = store.value.columns.filter((c) => c.checked)
  const opts = { ...params.value, columns: expColumns }
  loading.value = true
  const task = store.value.isPrint
    ? $grid.print?.(opts)
    : $grid.exportData?.({}, opts)
  Promise.resolve(task)
    .then(() => { store.value.visible = false })
    .finally(() => { loading.value = false })
}
</script>
